export const NOOP = () => {}

export const htmlRegex = /<([^\s>]+)(.*?)>(<\/\1>)?/gi

export const AppEnvs = {
  PRODUCTION: 'production',
  PLAYGROUND: 'playground',
  DEVELOPMENT: 'development',
} as const

export const NodeEnvs = {
  PRODUCTION: 'production',
  DEVELOPMENT: 'development',
  TEST: 'test',
} as const
